import { Injectable } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TokenService {

  loginAuth: string;
  private readonly urlAPI = environment.apiLogin;

  constructor(
    private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  public canActivate(): boolean | Observable<boolean> {

    this.loginAuth = sessionStorage.getItem('loginAuth');

    if (environment.mockToken) {
      // PARA LOGAR SEM TOKEN
      return new Observable<boolean>(observer => {
        observer.next(true);
        observer.complete();
      });
    } else {
      // PARA LOGAR COM TOKEN
      if (this.loginAuth) {
        return new Observable<boolean>(observer => {
          this.getDadosUser(this.loginAuth).then(data => {
            if (data.cpf) {
              observer.next(true);
              observer.complete();
            } else {
              window.location.href = environment.baseURL;
              return false;
            }
          });
        });
      } else {
        window.location.href = environment.baseURL;
        return false;
      }
    }
  }

  getDadosUser(token: any): Promise<any> {
    return this.validaToken(token)
    .then(data => data)
    .catch(error => error);
  }

  validaToken(token: any): Promise<any> {
    const url: string = this.urlAPI + `/getUserInfoBrasilCidadao?token=${token}`;
    return this.http.get(url)
    .toPromise()
    .then(response => response);
  }

}
